import { graphql } from "gql";

const EDIT_MESSAGE_THREAD_REMOVE_TAGS_MUTATION = graphql(`
  mutation EditMessageThreadRemoveTags($id: ID!, $tagIdList: [ID!]!) {
    editMessageThread(id: $id, input: { tagIdListToRemove: $tagIdList }) {
      id
      tagIdList
    }
  }
`);

export default EDIT_MESSAGE_THREAD_REMOVE_TAGS_MUTATION;
